import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "reactstrap";

import { ROL_KID, ROL_TEEN, ROL_ADULT } from "./PantallasRexistro";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { InfoPanel } from "@components/GUI/InfoPanel/InfoPanel";
import RegisterNavigationComponent from "../common/components/RegisterNavigationComponent";
import {
  SIGNUP_MODE,
  TENANT,
  TENANT_TIIVII,
  TENANT_TIIVII_SERVER,
} from "../../../../app/src/Resources/Multitenant/tenantConstants";
import { SIGNUP_MODE_SIMPLE } from "./RegisterConstant";
import { isUsernameValid } from "./NameUser";
import { handleShowPassword } from "../../../../app/src/Utils/utils";

let timeoutU = null;
let timeoutE = null;

function DataUser(props) {
  const { invalidUsername, invalidPassword, invalidEmail } = props;

  const [showPassword, setShowPassword] = useState([false, false]);
  const [nome, setNome] = useState("");
  const [apelido, setApelido] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [currentpassword, setCurrentpassword] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [birthdate, setBirthdate] = useState(null);
  const [showValidationErrors, setShowValidationErrors] = useState(false);
  const [UsernameInvalid, setUsernameInvalid] = useState(props.invalidUsername);
  const fieldRefs = useRef({});

  const { t } = useTranslation();
  const { updateUserData, gotoValidateToUpdateUserData, setDatosState } = props;
  const isTiiviiTenant = TENANT === TENANT_TIIVII || TENANT === TENANT_TIIVII_SERVER;
  const minRegisterAge = isTiiviiTenant ? 18 : 14;
  const defaultCalendarOpenDate = new Date(2005, 0, 1);
  const setBirthdateInParent =
    typeof props.ctrlSetBirthdate === "function"
      ? props.ctrlSetBirthdate
      : typeof props.ctrlSetBirthday === "function"
      ? props.ctrlSetBirthday
      : null;

  const maxBirthdate = new Date();
  maxBirthdate.setFullYear(maxBirthdate.getFullYear() - minRegisterAge);

  const isAdultRegistration =
    props?.datos?.rol === ROL_ADULT || SIGNUP_MODE === SIGNUP_MODE_SIMPLE;

  const getValidationErrors = () => {
    const isBirthdateAfterMax = !!birthdate && birthdate > maxBirthdate;

    return {
      nome: !nome,
      apelido: !apelido,
      email: !email || invalidEmail,
      birthdate: !birthdate || isBirthdateAfterMax,
      username:
        isAdultRegistration && (!username || UsernameInvalid || invalidUsername),
      password: isAdultRegistration && (!password || invalidPassword),
      password2:
        isAdultRegistration && (!password2 || password !== password2),
    };
  };

  const getFieldErrorMessage = (fieldName, errors) => {
    if (!errors[fieldName]) {
      return "";
    }

    switch (fieldName) {
      case "username":
        if (!username) return t("register.invalidfields");
        if (UsernameInvalid) {
          return t("register.invalidusernamechars", {
            defaultValue:
              "El nombre de usuario solo puede contener letras (excepto la ñ) sin acentos y números",
          });
        }
        return t("register.invalidusername");
      case "email":
        return !email ? t("register.invalidfields") : t("register.invalidemail");
      case "birthdate":
        if (!birthdate) return t("register.invalidfields");
        return t("register.invalidbirthdateage", {
          defaultValue: `Debes tener al menos ${minRegisterAge} años para registrarte`,
        });
      case "password":
        return !password
          ? t("register.invalidfields")
          : t("register.invalidpassword");
      case "password2":
        return !password2
          ? t("register.invalidfields")
          : t("register.invalidpassword2");
      default:
        return t("register.invalidfields");
    }
  };

  const getFirstInvalidField = (errors) => {
    const fieldsOrder = [
      "nome",
      "apelido",
      "birthdate",
      "email",
      "username",
      "password",
      "password2",
    ];
    return fieldsOrder.find((field) => errors[field]);
  };

  const scrollToField = (fieldName) => {
    const fieldElement = fieldRefs.current[fieldName];
    if (fieldElement?.scrollIntoView) {
      fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  //Inputs
  const handleChangeNome = (e) => {
    let n = e.target.value;
    setNome(n);
    props.ctrlSetFirstName(n);
  };

  const handleChangeApelido = (e) => {
    let n = e.target.value;
    setApelido(n);
    props.ctrlSetLastName(n);
  };

  const handleChangeUsername = (e) => {
    if (timeoutU) {
      clearTimeout(timeoutU);
    }
    const u = e.target.value;

    if (u.length > 0 && !isUsernameValid(u)) {
      setUsernameInvalid(true);
    } else {
      timeoutU = setTimeout(() => {
        props.ctrlSetUsername(u);
      }, 1500);
      setUsernameInvalid(false);
    }

    setUsername(u);
  };

  const handleChangeEmail = (e) => {
    const email = e.target.value;

    if (timeoutE) {
      clearTimeout(timeoutE);
    }

    setEmail(email);

    timeoutE = setTimeout(() => {
      props.ctrlSetEmail(email);
    }, 2500);
  };

  const handleChangeCurrentPassword = (e) => {
    let u = e.target.value;
    setCurrentpassword(u);
  };

  const handleChangePassword = (e) => {
    let u = e.target.value;
    setPassword(u);
  };

  const handleChangePassword2 = (e) => {
    let u = e.target.value;
    setPassword2(u);
  };

  const handleFinishPassword2 = (e) => {
    if (password === password2 && password2 !== null && password2 !== "") {
      props.ctrlSetCredentials(password2);
    }
  };

  const handleChangeBirthdate = (date) => {
    if (!date) {
      setBirthdate(null);
      setBirthdateInParent?.("");
      return;
    }

    const isAgeValid = date <= maxBirthdate;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    setBirthdateInParent?.(isAgeValid ? formattedDate : "");
    setBirthdate(date);
  };

  //Validacion
  const validar = () => {
    setShowValidationErrors(true);
    const validationErrors = getValidationErrors();
    const hasValidationErrors = Object.values(validationErrors).some(Boolean);

    if (hasValidationErrors) {
      const firstInvalidField = getFirstInvalidField(validationErrors);
      if (firstInvalidField) {
        scrollToField(firstInvalidField);
      }
      return;
    }

    props.validar(password2);
  };

  useEffect(() => {
    if (gotoValidateToUpdateUserData) {
      validar();
    }
  }, [gotoValidateToUpdateUserData]);

  const validationErrors = getValidationErrors();

  return (
    <div className="DataUser">
      <div className="WizardContainer">
        <div className="Descricion">
          {(props?.datos?.rol === ROL_KID ||
            props?.datos?.rol === ROL_TEEN) && (
            <>
              <div
                dangerouslySetInnerHTML={{
                  __html: t("register.titulodatauserkid"),
                }}
              ></div>
              <div
                className={"subTitle"}
                dangerouslySetInnerHTML={{
                  __html: t("register.textodatauserkid"),
                }}
              ></div>
            </>
          )}
          {(props?.datos?.rol === ROL_ADULT ||
            SIGNUP_MODE === SIGNUP_MODE_SIMPLE) && (
            <>
              <div
                dangerouslySetInnerHTML={{
                  __html: t("register.titulodatauserteen"),
                }}
              ></div>
            </>
          )}
        </div>
        {(props?.datos?.rol === ROL_KID || props?.datos?.rol === ROL_TEEN) && (
          <></>
        )}
        <Row className={"formFirstLine"}>
          <Col xs="12" md={6}>
            <label
              className="campoForm campoFirstName"
              ref={(el) => {
                fieldRefs.current.nome = el;
              }}
            >
              <input
                className={`InputNome ${showValidationErrors && validationErrors.nome ? "InputError" : ""}`}
                type="text"
                placeholder={t("register.datanome")}
                value={nome}
                onChange={handleChangeNome}
              />
              {showValidationErrors && validationErrors.nome && (
                <small className="birthdateErrorText">{getFieldErrorMessage("nome", validationErrors)}</small>
              )}
            </label>
          </Col>
          <Col xs="12" md={6}>
            <label
              className="campoForm campoLastName"
              ref={(el) => {
                fieldRefs.current.apelido = el;
              }}
            >
              <input
                className={`InputApelido ${showValidationErrors && validationErrors.apelido ? "InputError" : ""}`}
                type="text"
                placeholder={t("register.dataapelido")}
                value={apelido}
                onChange={handleChangeApelido}
              />
              {showValidationErrors && validationErrors.apelido && (
                <small className="birthdateErrorText">{getFieldErrorMessage("apelido", validationErrors)}</small>
              )}
            </label>
          </Col>
        </Row>
        <Row>
          <Col xs="12" md={6}>
            <div
              className="campoForm campoBirthdate"
              ref={(el) => {
                fieldRefs.current.birthdate = el;
              }}
            >
              <DatePicker
                selected={birthdate}
                onChange={handleChangeBirthdate}
                placeholderText={t("register.databirthdate")}
                dateFormat="dd/MM/yyyy"
                openToDate={defaultCalendarOpenDate}
                maxDate={maxBirthdate}
                className={`InputBirthdate datepicker-dropdown ${showValidationErrors && validationErrors.birthdate ? "InputError" : ""}`}
                popperPlacement="bottom-start"
                popperClassName="popperDatePicker"
                calendarClassName="UserDatePicker"
                withPortal
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"
              />
              {showValidationErrors && validationErrors.birthdate && (
                <small className="birthdateErrorText">
                  {getFieldErrorMessage("birthdate", validationErrors)}
                </small>
              )}
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs="12" md={6}></Col>
          <Col xs="12" md={6}></Col>
        </Row>
        <Row>
          <Col xs="12" md={6}>
            <label
              className="campoForm campoEmail"
              ref={(el) => {
                fieldRefs.current.email = el;
              }}
            >
              <input
                className={`InputEmail ${showValidationErrors && validationErrors.email ? "InputError" : ""}`}
                type="text"
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck={false}
                placeholder={t("register.dataemail")}
                value={email}
                onChange={handleChangeEmail}
              />
              {showValidationErrors && validationErrors.email && (
                <small className="birthdateErrorText">{getFieldErrorMessage("email", validationErrors)}</small>
              )}
            </label>
          </Col>
        </Row>

        {(props?.datos?.rol === ROL_ADULT ||
          SIGNUP_MODE === SIGNUP_MODE_SIMPLE) && (
          <Row>
            <Col xs="12" md={6}>
              <label
                className="campoForm campoUsername"
                ref={(el) => {
                  fieldRefs.current.username = el;
                }}
              >
                <input
                  className={`InputUsuario ${showValidationErrors && validationErrors.username ? "InputError" : ""}`}
                  type="text"
                  autoCapitalize="none"
                  autoCorrect="off"
                  spellCheck={false}
                  placeholder={t("register.datausername")}
                  value={username}
                  onChange={handleChangeUsername}
                />
                {showValidationErrors && validationErrors.username && (
                  <small className="birthdateErrorText">{getFieldErrorMessage("username", validationErrors)}</small>
                )}
              </label>
            </Col>
            <Col xs="12" md={6}>
              <label className="campoForm currentPassword">
                <h2>{t("register.updatepassword")}</h2>
                <input
                  className="InputPassword"
                  type={showPassword[0] ? "text" : "password"}
                  placeholder={t("register.currentpassword")}
                  value={currentpassword}
                  onChange={handleChangeCurrentPassword}
                />
                <div
                  className={"iconInput"}
                  onClick={() =>
                    setShowPassword(handleShowPassword(0, showPassword))
                  }
                >
                  <ion-icon
                    name={showPassword[0] ? "eye-outline" : "eye-off-outline"}
                    aria-label={showPassword[0] ? t("password.hide") : t("password.show")}
                  />
                </div>
              </label>
            </Col>
          </Row>
        )}
        <InfoPanel
          classButton={"passwordInfo"}
          classPanel={"Enumeracion"}
          icon={"fa fa-info-circle"}
          hideonclick={true}
          displayonvoer={true}
        >
          <span className={"Linea"}>{t("register.infopassword1")}</span>
          <span className={"Linea"}>{t("register.infopassword2")}</span>
          <span className={"Linea"}>{t("register.infopassword3")}</span>
          <span className={"Sublinea"}>{t("register.infopassword4")}</span>
        </InfoPanel>
        <Row>
          <Col xs="12" md="6">
            <label
              className="campoForm campoPassword"
              ref={(el) => {
                fieldRefs.current.password = el;
              }}
            >
              <input
                className={`InputPassword ${showValidationErrors && validationErrors.password ? "InputError" : ""}`}
                type={showPassword[0] ? "text" : "password"}
                placeholder={t("register.datapassword")}
                value={password}
                onChange={handleChangePassword}
              />
              <div
                className={"iconInput"}
                onClick={() =>
                  setShowPassword(handleShowPassword(0, showPassword))
                }
              >
                <ion-icon
                  name={showPassword[0] ? "eye-outline" : "eye-off-outline"}
                  aria-label={showPassword[0] ? t("password.hide") : t("password.show")}
                />
              </div>
              {showValidationErrors && validationErrors.password && (
                <small className="birthdateErrorText">{getFieldErrorMessage("password", validationErrors)}</small>
              )}
            </label>
          </Col>
          <Col xs="12" md="6">
            <label
              className="campoForm campoPassword2"
              ref={(el) => {
                fieldRefs.current.password2 = el;
              }}
            >
              <input
                className={`InputPassword ${showValidationErrors && validationErrors.password2 ? "InputError" : ""}`}
                type={showPassword[1] ? "text" : "password"}
                placeholder={t("register.datapassword2")}
                value={password2}
                onChange={handleChangePassword2}
                onBlur={handleFinishPassword2}
              />
              <div
                className={"iconInput"}
                onClick={() =>
                  setShowPassword(handleShowPassword(1, showPassword))
                }
              >
                <ion-icon
                  name={showPassword[1] ? "eye-outline" : "eye-off-outline"}
                  aria-label={showPassword[1] ? t("password.hide") : t("password.show")}
                />
              </div>
              {showValidationErrors && validationErrors.password2 && (
                <small className="birthdateErrorText">{getFieldErrorMessage("password2", validationErrors)}</small>
              )}
            </label>
          </Col>
        </Row>
      </div>
      {!updateUserData && (
        <RegisterNavigationComponent
          handlerBeforePage={props.anteriorPantalla}
          handlerNextPage={validar}
        />
      )}
    </div>
  );
}

export default DataUser;
